import { Options } from "vue-class-component";
import BaseTableInterface from "@/mixins/BaseTableInterface";
import BaseTableMixins from "@/mixins/BaseTable";
import TodoListTableItem from "@/entity/flowable/TodoListTableItem";
import ProcessWorkspace from "@/modules/flowable/workspace/process-workspace/process-workspace.vue";
import API from "@/api/flowable/workspace/todo";

@Options({
    name: "app-flowable-workspace-todo",
    components: {
        ProcessWorkspace,
    },
})
export default class Todo extends BaseTableMixins<TodoListTableItem> implements Partial<BaseTableInterface<TodoListTableItem>> {
    public created(): void {
        this.setInterface(this);
        this.editTableItem = new TodoListTableItem();
        this.editModalItem = new TodoListTableItem();
    }

    public activated(): void {
        this.getList(1);
    }

    //后端API
    public getApi(): any {
        return API;
    }

    //处理流程
    public flowProcessing(item: any) {
        item.isProcess = true;
        (this.$refs.processView as any).show(item);
    }

    //流程提交
    public onFlowSubmit(e: any) {
        if ("RefreshTable" === e) this.getList(0);
    }
}
